// extracted by mini-css-extract-plugin
export default {"container":"CertificatePage_container__tnvkQ","header":"CertificatePage_header__VS1gP","title":"CertificatePage_title__7Bc84"};